import React, { useEffect, useState } from "react";
import MainContainer from "../../components/main-container/MainContainer";
import { Button, Divider } from "@mui/material";
import { useLocation } from "react-router-dom";
import { InvokePostServiceCall } from "../../api/apiServices";
import { API } from "../../constants/APIConstant";
import { Spinner } from "react-bootstrap";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  Document,
  Packer,
  Paragraph,
  HeadingLevel,
  TextRun,
  AlignmentType,
  SectionType,
  LineRuleType,
  ExternalHyperlink,
} from "docx";
import { saveAs } from "file-saver";

function ClusterDetails() {
  const location = useLocation();
  const [projectInfo, setProjectInfo] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let requestBody = {
      project_name: location?.state?.projectId,
      created_by: location?.state?.createdBy,
    };

    InvokePostServiceCall(API.clustering_get_info, requestBody)
      .then((response) => response.json())
      .then((result) => {
        setProjectInfo(result);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        //   notify();
        setLoading(false);
      });
  }, []);

  const handleGenerateDoc = (isDoc = true) => {
    try {
      // setShowSpinner(true);
      // saveDocumnet();
      const urlRegex = /(https?:\/\/[^\s]+)/;
      let arr = [];
      arr.push({
        properties: {
          type: SectionType.CONTINUOUS,
        },
        children: [
          new Paragraph({
            text: `${location?.state?.projectId} Result`,
            heading: HeadingLevel.TITLE,
            alignment: AlignmentType.CENTER,
            children: [new TextRun({ text: "", break: 1 })],
          }),
        ],
      });
      projectInfo.forEach((item, index) => {
        arr[0].children.push(
          new Paragraph({
            // text: `Topic: ${item.topic}`,
            text: `${item.cluster}`,
            heading: HeadingLevel.HEADING_1,
            // thematicBreak: true,
            // pageBreakBefore: index !== 0,
            children: [new TextRun({ text: `Topic: ${item.topic}`, break: 1 })],
          })
        );
        arr[0].children.push(
          new Paragraph({
            // text: `Topic: ${item.topic}`,
            text: `Documents:`,
            heading: HeadingLevel.HEADING_1,
            // thematicBreak: true,
            // pageBreakBefore: index !== 0,
            //  children: [new TextRun({ text: `Topic: ${item.topic}`, break: 1 })],
          })
        );
        let list = Object.keys(item.documents).map((text) => {
          const isLink = urlRegex.test(item?.documents[text]);
          const link = item?.documents[text].match(urlRegex);
          const textRun = isLink
            ? new ExternalHyperlink({
                children: [
                  new TextRun({
                    text: text,
                    style: "Hyperlink",
                    break: 1,
                  }),
                ],
                link: link ? link[0] : "",
              })
            : new TextRun({
                text: item?.documents[text],
                break: 1,
              });
          return textRun;
        });

        arr[0].children.push(
          new Paragraph({
            // keepLines: true,
            // keepNext: true,
            // spacing: {
            //   before: 0,
            //   after: ,
            //   lineRule: LineRuleType.EXACT,
            // },
            children: list,
          })
        );

        arr[0].children.push(
          new Paragraph({
            // text: `Topic: ${item.topic}`,
            text: ``,
            heading: HeadingLevel.HEADING_1,
            spacing: {
              before: 0,
              after: 300,
              lineRule: LineRuleType.EXACT,
            },
            thematicBreak: true,
            // pageBreakBefore: index !== 0,
            //  children: [new TextRun({ text: `Topic: ${item.topic}`, break: 1 })],
          })
        );
      });

      const doc = new Document({
        sections: arr,
        compatibility: {
          version: 15,
          doNotExpandShiftReturn: true,
        },
      });
      Packer.toBlob(doc).then(async (blob) => {
        if (true) {
          // let uriArr = [];
          // uriArr.push(URL.createObjectURL(blob));
          saveAs(blob, `${location.state.projectId} Result` + ".docx");
          // setShowSpinner(false);
          // setBlob({ uri: uriArr, blob: blob });
        } else {
        }
      });
    } catch (error) {
      console.log("error: ", error);
      // setShowSpinner(false);
      // notify();
    }
  };

  return (
    <MainContainer showHomeButton={true}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "6px",
        }}
      >
        <h3>Result</h3>

        <Button
          variant="contained"
          endIcon={<DescriptionIcon />}
          sx={{
            backgroundColor: "#004987",
            height: "39px",
            "&:hover": { backgroundColor: "#004987" },
          }}
          disabled={projectInfo.length < 1}
          onClick={() => {
            handleGenerateDoc();
          }}
        >
          Generate Doc
        </Button>
      </div>
      <Divider sx={{ backgroundColor: "grey", marginBottom: "15px" }} />
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "calc(100vh - 200px)",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      )}
      {projectInfo.length > 0 && (
        <div
          style={{
            border: "1px solid grey",
            padding: "2%",
            borderRadius: "15px",
            margin: "0px 15px 15px 15px",
          }}
        >
          {projectInfo.map((item, index) => {
            return (
              <div key={index} style={{ marginBottom: "15px" }}>
                <h5>{item.cluster}</h5>
                <h6>Topic: {item.topic}</h6>
                <h6>Documents:</h6>
                {Object.keys(item.documents).map((doc) => {
                  return (
                    <div>
                      <a href={item?.documents[doc]}>{doc}</a>
                    </div>
                  );
                })}
                <Divider sx={{ backgroundColor: "grey", marginTop: "15px" }} />
              </div>
            );
          })}
        </div>
      )}
    </MainContainer>
  );
}

export default ClusterDetails;
